import { ReceiptAPI } from "../api";
import { DocumentItem } from "./DocumentItem.class";
import Helper from "../plugins/Helper/Helper";
import moment from "moment";
import Vue from "vue";
import i18n from '@/plugins/vue-i18n';
export class Receipt {
  constructor(data, isToMainCurrency, isRaw) {
    this.isRaw = isRaw;
    this.data = data;
    this.objectId = data.objectId;
    this.createdAt = data.createdAt;
    this.isVatInclusive = data.isVatInclusive || false;
    this.project = data.project;
    this.market = data.market;
    this.marketName = this.market ? this.market.name : ''
    this.contract = data.contract;
    this.createdBy = data.createdBy;
    this.meterMonth = data.meterMonth;
    this.meterYear = data.meterYear;
    this.month = data.month;
    this.year = data.year;
    this.runningNumber = data.runningNumber;
    this.documentId = data.documentId;
    this.documentType = data.documentType;
    this.companyData = data.companyData || {};
    this.customerData = data.customerData || {};
    this.date = data.date ? data.date.iso : null;
    this.dueDate = data.dueDate ? data.dueDate.iso : null;
    this.sentBy = data.sentBy;
    this.note = data.note;
    this.vatPercent = data.vatPercent || Vue.prototype.$globalVatPercent || 7
    this.isSent = data.isSent || false;
    this.isPaid = data.isPaid || false;
    this.receipts = data.receipts || [];
    this.isVat = data.isVat;
    this.paymentMethod = data.paymentMethod;
    this.paymentBankAccount = data.paymentBankAccount;
    this.paymentNote = data.paymentNote;
    this.cancelledNote = data.cancelledNote;
    this.paymentProofFiles = data.paymentProofFiles;
    this.voucherNumber = data.voucherNumber;
    this.invoice = data.invoice;
    this.projectCode = data.projectCode || null;
    this.booking = data.booking;
    this.qrPaymentReport = data.qrPaymentReport;
    this.refAccId = data.refAccId;
    this.order = data.order;
    this.currencyCode = data.currencyCode || Vue.prototype.$globalCurrencyCode || "THB";
    this.items = [];
    this.areaName = "-"
    this.paymentCurrencyCode = data.paymentCurrencyCode || this.currencyCode;
    this.totalPaymentValue = data.totalPaymentValue || 0;
    this.exchangeRate = data.exchangeRate || 1;
    this.totalExchangedValue = data.totalExchangedValue || 0;
    this.totalFxAainLossValue = data.totalFxAainLossValue || 0;
    this.currencyRate = data.currencyRate;
    this.exchangeRateToMainCurrency = 1
    if (this.currencyRate?.data && this.currencyCode != Vue.prototype.$globalCurrencyCode) {
      if (this.paymentCurrencyCode == Vue.prototype.$globalCurrencyCode) {
        this.currencyRate.data[this.currencyCode][this.paymentCurrencyCode].value = this.totalPaymentValue / data.totalValue
      }
    }
    if (isToMainCurrency && this.currencyCode != Vue.prototype.$globalCurrencyCode) {
      let dataCurrencyRate = this.currencyRate || store.getters["currencyRate/getLastCurrencyRate"]
      if (dataCurrencyRate) this.exchangeRateToMainCurrency = dataCurrencyRate.data?.[this.currencyCode]?.[Vue.prototype.$globalCurrencyCode]?.value || 1
      this.currencyCode = Vue.prototype.$globalCurrencyCode || "THB"

      if (isRaw) {
        this.data.totalValue *= this.exchangeRateToMainCurrency
        this.data.totalNonVatValue *= this.exchangeRateToMainCurrency
        this.data.totalVatValue *= this.exchangeRateToMainCurrency
        this.data.totalWhtValue *= this.exchangeRateToMainCurrency
        this.data.totalDiscountValue *= this.exchangeRateToMainCurrency
        this.data.totalVatItemsValue *= this.exchangeRateToMainCurrency
        this.data.totalNonVatItemsValue *= this.exchangeRateToMainCurrency
      }
    }
    if (data.items && data.items.length) {
      let name = [];
      for (let item of data.items) {
        this.items.push(
          new DocumentItem(
            item,
            data.isVatInclusive,
            this.vatPercent,
            this.projectCode,
            null,
            this.exchangeRateToMainCurrency
          )
        );

        if (item.area && item.area.name && item.area.name != "-") {
          name.push(item.area.name);
        }
      }
      this.areaName = [...new Set(name)].sort().join(",") || "-"
    } else {
      this.items.push(
        new DocumentItem(
          {},
          this.isVatInclusive,
          this.vatPercent,
          this.projectCode,
          null,
          this.exchangeRateToMainCurrency
        )
      );
    }

    this.tels = [""];
    this.emails = [""];

    if (this.customerData) {
      this.tels = this.customerData?.tel?.split(",");
      this.emails = this.customerData?.email?.split(",");
      this.customerDataName = this.customerData.name
    }

    if(data.booking) {
      this.businessName = data.booking.businessName ? data.booking.businessName : '-'
    }
    if(data.contract) {
      this.businessName = data.contract.businessName ? data.contract.businessName : '-'
    }

    this.documentTypeString = Receipt.getDocumentTypeString(data.documentType)
    this.contractCustomerMarketId = this.contract && this.contract.customerMarketId ? this.contract.customerMarketId : '-'
    this.paymentMethodText = this.paymentMethod ? i18n.t('payment.methods.' + this.paymentMethod) : ''
    this.createdByText = this.createdBy ? `${this.createdBy.firstName} ${this.createdBy.lastName}` : ''
  }


  get status() {
    if (this.isPaid) {
      return i18n.t('payment.paid');
    } else if (this.documentId && !this.isPaid) {
      return i18n.t('payment.cancel_payment');
    } else {
      return i18n.t('payment.pending');
    }
  }

  static getDocumentTypeString(documentType) {
    return documentType ? i18n.t(`bill.document_type.${documentType}`) : "";
  }
  
  static async createReceipt(postData) {
    const { data } = await ReceiptAPI.createReceipt(postData);
    return new Receipt(data.result);
  }

  static async updateReceipt(postData) {
    const { data } = await ReceiptAPI.updateReceipt(postData);
    return new Receipt(data.result);
  }

  static async updateReceiptCustomerData(postData) {
    const { data } = await ReceiptAPI.updateReceiptCustomerData(postData);
    return new Receipt(data.result);
  }

  static async payReceipt(postData) {
    const { data } = await ReceiptAPI.payReceipt(postData);
    return new Receipt(data.result);
  }

  static async unpaidReceipt({ id, note }) {
    const { data } = await ReceiptAPI.unpaidReceipt({ id, note });
    return new Receipt(data.result);
  }

  static async getReceiptsByInvoice(receiptId) {
    const { data } = await ReceiptAPI.getReceiptsByInvoice(receiptId);
    return data.result.map(item => new Receipt(item));
  }

  get totalOriginalValue() {
    return this.items.reduce((a, b) => a + (b.totalOriginalValue || 0), 0);
  }

  static async getReceiptsBetweenDateByMarket(fromData) {
    const { data } = await ReceiptAPI.getReceiptsBetweenDateByMarket(fromData);
    let temp = data.result.map(item => new Receipt(item, fromData.isToMainCurrency, fromData.isRaw));
    const res = temp.sort((a, b) => {
      if (moment(a.date).endOf('day').format('YYYY-MM-DD') == moment(b.date).endOf('day').format('YYYY-MM-DD')) {
        return moment(a.createdAt) - moment(b.createdAt);
      }
      return moment(a.date) - moment(b.date);
    });
    return res;
  }

  static async getReceiptsBetweenDateByProject(fromData) {
    const { data } = await ReceiptAPI.getReceiptsBetweenDateByProject(fromData);
    let temp =  data.result.map(item => new Receipt(item));
    const res = temp.sort((a, b) => {
      if (moment(a.date).endOf('day').format('YYYY-MM-DD') == moment(b.date).endOf('day').format('YYYY-MM-DD')) {
        return moment(a.createdAt) - moment(b.createdAt);
      }
      return moment(a.date) - moment(b.date);
    });
    return res;
  }


  static async getReceipt(receiptId) {
    const { data } = await ReceiptAPI.getReceipt(receiptId);
    return new Receipt(data.result);
  }

  static async getDepositReceiptsByContracts(payload) {
    const { data } = await ReceiptAPI.getDepositReceiptsByContracts(payload);
    return data.result.map(item => new Receipt(item, payload.isToMainCurrency));
  }

  static async getReceiptOverallMonthly(fromData) {
    const { data } = await ReceiptAPI.getReceiptOverallMonthly(fromData);
    return data.result;
  }

  get totalVatValue() {
    if (this.isRaw) {
      return this.data.totalVatValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalVatValue || 0), 0));
    }
  }

  get totalValue() {
    if (this.isRaw) {
      return this.data.totalValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalValue || 0), 0));
    }
  }

  get totalNonVatValue() {
    if (this.isRaw) {
      return this.data.totalNonVatValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalNonVatValue || 0), 0));
    }
  }

  get totalVatItemsValue() {
    if (this.isRaw) {
      return this.data.totalVatItemsValue;
    } else {
      return Helper.round(
        this.items
          .filter(d => {
          return d.sellVatType == 1;
        })
        .reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
      );
    }
  }

  get totalNonVatItemsValue() {
    if (this.isRaw) {
      return this.data.totalNonVatItemsValue;
    } else {
      return Helper.round(
        this.items
          .filter(d => {
          return d.sellVatType != 1;
        })
          .reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
      );
    }
  }

  get totalWhtValue() {
    if (this.isRaw) {
      return this.data.totalWhtValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalWhtValue || 0), 0))
    }
  }

  get totalDiscountValue() {
    if (this.isRaw) {
      return this.data.totalDiscountValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalDiscountValue || 0), 0));
    }
  }
}
